module.exports = __webpack_public_path__ + "img/google-dev-day-2016.7c24a39d.jpg";